import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { EasmAssetsInventoryGridController } from '../controller/EasmAssetsInventoryGridController';

export class EasmAssetsInventoryGridWebComponent extends BaseWebComponentElement {
  public controller!: EasmAssetsInventoryGridController;

  public constructor() {
    super();

    this.initialSetup({
      controllerConstructor: EasmAssetsInventoryGridController,
    });
  }

  getCompanyIdFilterValue(): string {
    return this.controller.getCompanyIdFilterValue();
  }
}
